import React, { useEffect } from 'react';
import TopQuestion from '../../utils/question/topQuestion';
import { connect } from 'react-redux';
import ClozeRecorder from './clozeRecorder';
import ClozeOptions from './clozeOptions';
import { appendScript } from '../../../../utils/appendScript';
import { removeScript } from '../../../../utils/removeScript';

const mapStateToProps = (state) => {
    const {
        rightSectionProps,
        isMicPermitted,
        isFeedback,
    } = state.rootReducer.testPageDetails;

    return {
        rightSectionProps,
        isMicPermitted,
        isFeedback,
    }
}

const ClozeConversation = ({
    rightSectionProps: {
        clozeQuestion,
        questionId,
    },
    isFeedback,
}) => {

    useEffect(() => {
        if (!isFeedback) {
            appendScript('clozeConversation');
        }
        return () => {
            removeScript('clozeConversation');
        }
    }, [isFeedback, clozeQuestion]);

    var clozeQ = '';
    var recordContainer = [];
    if (!!clozeQuestion) {
        var clozeQue = clozeQuestion.split('\n');
        var key = -1;
        clozeQ = clozeQue.map((val, k) => {
            if (val.includes("[blank]")) {
                key++;
                let id = `${questionId}_${key}`;
                recordContainer.push(<ClozeRecorder key={id} dataContainer={id} index={key} />);
                return (
                    <div className="converse-container" key={id} data-container={id} index={key} id={id}>
                        <div className="converse-box ">
                            <p tabIndex="0" className="converse-nil">{val.replace('[blank]', '')}
                                <span className="_blank">Choose</span>
                                </p>
                                <div className="converse-all">
                                <ClozeOptions dataContainer={id} />
                            </div>
                        </div>
                    </div>
                )
            } else {
                return (<div key={k} className="converse-container">
                    {!!val && <div className="converse-box">
                        <p>{val}</p>
                    </div>}
                </div>)
            }
        })
    }

    return (
        <section className="que-container ">
            <section className="quiz-page-content">
                <TopQuestion />
                <p style={{ display: "none" }} className="error test_validation" id="errorWordcloudPage">Please answer the question</p>
                <section className="quiz-area-options">
                    {clozeQ}
                    {recordContainer}
                    <input type="hidden" id="clozeResponse" name="clozeResponse" />
                </section>
            </section>
        </section>
    )
}

export default connect(mapStateToProps)(ClozeConversation);